module.exports = __webpack_public_path__ + "static/media/pie-chart-borough.3809cc48.svg";